import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetReferralDetailsParams,
	ReferralDetails,
} from 'domain/usecases/private/my-referrals-flow/get-referrals-details';
import {GetReferralDetailsList} from './referral-details';

export class RemoteGetReferralDetails implements GetReferralDetailsList {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<ReferralDetails>,
	) {}

	async get({signal, cdSenha}: GetReferralDetailsParams): Promise<ReferralDetails> {
		const httpResponse = await this.httpClient.request({
			url: `${this.url}`,
			method: 'get',
			params: {cdSenha},
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;

			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
